<template>
	<div>
		<form @submit.prevent="submit">
			<div class="row">
				<form-select
					v-model="educacao.interrupcao_estudos"
					:itens="$root.arrays.pergunta"
					label="Houve interrupção nos estudos?"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="educacao.dificuldade_aprendizagem"
					:itens="$root.arrays.pergunta"
					label="Apresenta dificuldade de aprendizagem"
					:required="true"
					grid="6"
				/>
				<form-select
					v-model="educacao.frequenta_programa_social"
					:itens="$root.arrays.pergunta"
					label="Frequenta Programas Sociais – contra turno escolar?"
					:required="true"
					grid="6"
				/>
				<form-input
					v-if="educacao.frequenta_programa_social == 1"
					v-model="educacao.unidade_programa_social"
					label="Qual a unidade?"
					:required="true"
					grid="6"
				/>
				<form-textarea
					v-model="educacao.metodo_aprendizagem"
					label="Qual método de ensino teria maior facilidade de aprendizagem em razão do seu perfil comportamental:"
					:required="true"
				/>
				<form-textarea
					v-model="educacao.consideracao_escolar"
					label="Considerações sobre a vida escolar (frequência,comportamento, aprendizagem):"
					:required="true"
				/>
			</div>
			<div class="row pt-4 px-0 d-flex justify-content-end">
				<div class="col-auto px-2 text-right">
					<button class="btn btn-success btn-submit" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Salvar") }}
					</button>
				</div>
			</div>
		</form>
	</div>
</template>
<script>
export default {
	props: ["item"],
	data() {
		return { educacao: {} };
	},
	mounted() {
		if (this.item.educacao != null) {
			this.educacao = this.item.educacao;
		}
	},
	methods: {
		submit() {
			this.item.educacao = this.educacao;
			this.$emit("submit");
		},
	},
};
</script>
